import { render } from "./FormsListView.vue?vue&type=template&id=0405d7dc"
import script from "./FormsListView.vue?vue&type=script&lang=js"
export * from "./FormsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__